module.exports = __webpack_public_path__ + "media/images/bullhorn-e7d59a1c70d1092f5b1e8f304413696d.svg";